<template>
    <div>
        <div v-if="busy">
            <!-- We're loading. Show something here or no? -->
        </div>
        <div v-else>
            <div class="d-flex justify-content-center mt-5" >
                <div style="max-width: 670px;" class=" mx-auto">
                    <div v-if="collection && currentAccountOverview && !hasSuggestionsLoaded">
                        <h3>This Collection has no suggestions to display currently.</h3>
                        <p>Adjust the filtering options or add a suggestion to a Collection by clicking the button at the bottom right of each suggestion card.</p>
                        <div class="img my-3 img-fluid img-empty-collection" :style="{'height' : '13rem'}">
                            <span class="mg-fluid"></span>
                        </div>
                        <p class="text-center">Or, you can <a @mouseout="hideTheArrow()" @mouseover="showTheArrow()"
                                                         href="#"
                                           @click="showAddUrlModal()">add suggestions via url</a>.</p>
                        <div class="img img-fluid mx-5 img-suggestion-url" :style="{'height' : '7rem'}">
                            <span></span>
                        </div>
                    </div>
                    <div v-else-if="currentAccountOverview && !currentAccountOverview.collections.length">
                        <h3>You have no Collections at the moment.</h3>
                        <p>Add your first Collection here.</p>
                        <!-- <p class="small">What are <a href="#" target="_blank">collections</a>?</p> -->
                        <button @click="showCollectionBuilder()" class="btn btn-outline-danger"><i class="fa fa-plus"></i> New Collection</button>
                    </div>
                    <div v-else-if="!currentAccountOverview">
                        <spinner></spinner>
                        <h3>Loading account details</h3>
                    </div>
                    <div v-else-if="collections.length > 0 & currentCollection">
                        <spinner></spinner>
                        <h3>Loading current Collection</h3>
                    </div>
                    <div v-else-if="currentAccountOverview.collections.length > 0 & !currentCollection">
                        <h3>Create or select a Collection</h3>
                    </div>
                    <p class="mb-0 mt-2 text-center"><a href="#" @click.prevent="goToTopics()">Go to my Topics</a></p>
                </div>

            </div>
        </div>
        
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import Spinner from "@/components/Controls/Spinner.vue";

export default {
    components: {Spinner},
    props : ['busy', 'collection'],
    methods : {
        goToTopics(){
            this.$store.dispatch('setSuggestionViewerType', {type : 'topics'});
        },
        showCollectionBuilder(){
            window.Events.$emit('show_editCollectionModal', {collection: null});
        },
        showAddUrlModal(){
            window.Events.$emit('showAddUrlToCollectionModal')
        },
        showTheArrow(){
            window.Events.$emit('showAddUrlAttentionGrabber');
        },
        hideTheArrow(){
            window.Events.$emit('hideAddUrlAttentionGrabber');
        }
    },
    computed: {
        ...mapGetters({
            hearsay: 'isHearsay',
            currentAccountOverview: 'currentAccountOverview',
            collections: 'collections',
            currentCollection: 'currentCollection',
            suggestions: 'suggestions',
        }),
        hasSuggestionsLoaded() {
            return this.suggestions && this.suggestions.length > 0;
        }
    }
}
</script>

<style>
.img-empty-collection {
    display: flex;
    align-items: center;
    object-fit: contain;
}

.img-empty-collection span {
    background-image: url('@/assets/images/empty-collection.png');
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
}

@media (max-width: 800px) {
    .img-empty-collection {
        height: 8rem !important;
    }
    .img-empty-collection span {
        background-size: 300px;
    }
}

.img-suggestion-url {
    display: flex;
    align-items: center;
}

.img-suggestion-url span {
    background-image: url('@/assets/images/suggestions_url.png');
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
}

</style>
